export enum VoteResult {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export const DateFormat = {
  Date: 'dd. MM. yyyy',
  DateTime: 'dd. MM. yyyy',
};
